<app-content-header
  text="Preferred Location"
  [showEdit]="true"
  (editClicked)="handleClicked()"
  firebase="myProfile_editPreferredLocation"
></app-content-header>
<div class="location-tile-list-container mb-3">
  <div
    *ngFor="let location of myProfileService.locationList$ | async | slice:0:1"
    class="location-tile-container"
  >
    <app-location-tile
      [locationData]="location"
      [isPreferred]="true"
    ></app-location-tile>
  </div>
</div>
<app-content-header text="Locations"></app-content-header>
<span
  *ngIf="(myProfileService.locationList$ | async)?.length === 1"
  class="lato"
>You have no other visited locations.</span>
<div class="location-tile-list-container">
  <div
    class="location-tile-container"
    *ngFor="let location of myProfileService.locationList$ | async | slice:1"
  >
    <app-location-tile
      *ngIf="location.id !== myProfileService.preferredLocation.id"
      [locationData]="location"
    ></app-location-tile>
  </div>
</div>